import React, { PropsWithChildren, useState } from "react";
import { InvoiceListFilters } from "./invoice/InvoiceTableProvider";

export interface SelectedInvoiceData {
  IOID: number;
  pending: number;
  CurrencyID: number;
}

export const ClientDetailProvider = ({
  children,
  reloadExtraData = undefined
}: PropsWithChildren<{ reloadExtraData?: () => void }>) => {
  const [invoiceIds, setInvoiceIds] = useState<number[]>([]);
  const [invoiceCount, setInvoiceCount] = useState<number>(0);
  const [invoiceFilters, setInvoiceFilters] = useState<InvoiceListFilters>({
    quickfilter: "",
    extraFilters: [],
    quickExtraFilter: "",
    iotree: ""
  });
  const [selectedInvoiceData, setSelectedInvoiceData] = useState<
    Map<number, SelectedInvoiceData>
  >(new Map());

  return (
    <ClientDetailContext.Provider
      value={{
        invoiceIds,
        setInvoiceIds,
        invoiceCount,
        setInvoiceCount,
        invoiceFilters,
        setInvoiceFilters,
        selectedInvoiceData,
        setSelectedInvoiceData,
        reloadExtraData: reloadExtraData ?? (() => undefined)
      }}
    >
      {children}
    </ClientDetailContext.Provider>
  );
};

export class ClientDetailContextValues {
  invoiceIds: number[] = [];
  invoiceCount = 0;
  invoiceFilters: InvoiceListFilters = {
    quickfilter: "",
    extraFilters: [],
    quickExtraFilter: "",
    iotree: ""
  };
  selectedInvoiceData: Map<number, SelectedInvoiceData> = new Map();

  setInvoiceIds: (ids: number[] | ((prev: number[]) => number[])) => void =
    () => {
      throw Error("error");
    };
  setInvoiceCount: (count: number) => void = () => {
    throw Error("error");
  };
  setInvoiceFilters: (filters: InvoiceListFilters) => void = () => {
    throw Error("error");
  };
  setSelectedInvoiceData: (
    data:
      | Map<number, SelectedInvoiceData>
      | ((
          prev: Map<number, SelectedInvoiceData>
        ) => Map<number, SelectedInvoiceData>)
  ) => void = () => {
    throw Error("error");
  };
  reloadExtraData: () => void = () => {
    throw Error("error");
  };
}
const ClientDetailContext = React.createContext<ClientDetailContextValues>(
  new ClientDetailContextValues()
);
export default ClientDetailContext;
